module.exports = __webpack_public_path__ + "img/default_cover.c2ba8916.png";